import type { PointData } from '../points/point.types';

export interface DropdownPointData extends PointData {
    separated?: boolean;
    onselect?: () => void;
}

export type DropdownPoints = Record<string, DropdownPointData>;

/** Dropdown.svelte stellt darüber eine Funktion bereit, mit der ein Punkt das Panel schliessen kann. */
export const CLOSE_CONTEXT_KEY = 'dropdown-close';
export type CloseFn = () => void;
